import React, { useEffect } from 'react';
import './LogOutPage.css';
import { useAuth } from "react-oidc-context";


export const LogoutPage = () => {

  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated) {
      auth.signoutRedirect({
        extraQueryParams: {
          client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
          redirect_uri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI || '',
          response_type: 'code'
        }
      });
    }
  }, [auth.isAuthenticated])

  return <></>;
};
